import { render, staticRenderFns } from "./AchievementNotificationComponent.vue?vue&type=template&id=7365f89a&scoped=true"
import script from "./AchievementNotificationComponent.vue?vue&type=script&lang=js"
export * from "./AchievementNotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./AchievementNotificationComponent.vue?vue&type=style&index=0&id=7365f89a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365f89a",
  null
  
)

export default component.exports